import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

import { Paper } from '@mui/material';

import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';

import ReservationService from '../../../services/ReservationService';
import VendorsService from '../../../services/VendorsService';
import Asinc from '../../Common/Asinc';
import PropertyForm from '../../Common/Forms/PropertyForm';

export default class PropertyNewContainer extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    this.vendorId = match.params.id_vendor;

    this.fetchData = this.fetchData.bind(this);
  }

  async fetchData() {
    const [reservationSchema, vendor] = await Promise.all([
      ReservationService.getPropertiesSchema(),
      VendorsService.getVendorById(this.vendorId),
    ]);

    return {
      schema: reservationSchema.post.body.schema,
      vendor: vendor.result,
    };
  }

  render() {
    return (
      <div className="container property-edit-form">
        <Asinc
          promise={this.fetchData()}
          then={({ schema, vendor }) => {
            const property = { id_salesforce_external: this.vendorId };

            return (
              <>
                <Helmet>
                  <title>Vendors | {vendor?.name || this.vendorId} | Create Property</title>
                </Helmet>
                <OfferBreadcrumbs
                  vendor={{
                    label: vendor?.vendor_name || vendor?.name || 'Vendor',
                    href: `/vendors/${this.vendorId}`,
                  }}
                  currentPage="Create property"
                />
                <PageHeader title="Create Property" />
                <Paper id="overview" className="property-deal-section">
                  <PropertyForm schema={schema} property={property} vendorId={this.vendorId} />
                </Paper>
              </>
            );
          }}
        />
      </div>
    );
  }
}
